import * as React from "react";

// Top-view fountain - circular basin with water ripples
function FountainIcon({ color = "#2196F3", width = 40, height = 40, name }) {
  return (
    <div style={{ textAlign: "center" }}>
      {name && <p style={{ margin: 0, fontSize: "10px", userSelect: "none" }}>{name}</p>}
      <svg
        viewBox="0 0 100 100"
        height={height}
        width={width}
      >
        {/* Outer basin rim */}
        <circle cx="50" cy="50" r="48" fill="#78909C" />
        <circle cx="50" cy="50" r="44" fill="#607D8B" />
        {/* Water */}
        <circle cx="50" cy="50" r="40" fill={color} opacity="0.8" />
        {/* Water ripples */}
        <circle cx="50" cy="50" r="32" fill="none" stroke="#fff" strokeWidth="2" opacity="0.5" />
        <circle cx="50" cy="50" r="24" fill="none" stroke="#fff" strokeWidth="2" opacity="0.4" />
        <circle cx="50" cy="50" r="16" fill="none" stroke="#fff" strokeWidth="2" opacity="0.3" />
        {/* Center spout */}
        <circle cx="50" cy="50" r="8" fill="#455A64" />
        <circle cx="50" cy="50" r="4" fill="#37474F" />
      </svg>
    </div>
  );
}

export default FountainIcon;
